const config = {
  apiGateway: {
    BASE_URL_1: process.env.REACT_APP_API_URL
  }
}

export default config
